export default function HomeInsta() {
  return null;
}
